document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.getElementById("priceChart");

  // Set the internal resolution of the canvas.
  canvas.width = 800;
  canvas.height = 400;

  const ctx = canvas.getContext("2d");

  // Hard-coded data showing grocery prices over the years.
  const data = [
    { year: 2015, price: 100 },
    { year: 2016, price: 105 },
    { year: 2017, price: 110 },
    { year: 2018, price: 115 },
    { year: 2019, price: 120 },
    { year: 2020, price: 130 },
    { year: 2021, price: 140 },
    { year: 2022, price: 150 },
    { year: 2023, price: 160 },
  ];

  // Determine maximum price for scaling purposes.
  const maxPrice = Math.max(...data.map((d) => d.price));
  const padding = 50; // padding around the graph area

  // Calculate the width of each bar with a gap between them.
  const gap = 20;
  const barWidth =
    (canvas.width - padding * 2 - gap * data.length) / data.length;

  // Draw axes (Y-axis and X-axis)
  ctx.beginPath();
  ctx.moveTo(padding, padding);
  ctx.lineTo(padding, canvas.height - padding);
  ctx.lineTo(canvas.width - padding, canvas.height - padding);
  ctx.strokeStyle = "#333";
  ctx.lineWidth = 2;
  ctx.stroke();

  // Draw Y-axis labels and grid lines.
  const numYLabels = 5;
  for (let i = 0; i <= numYLabels; i++) {
    const yValue = (maxPrice * i) / numYLabels;
    const y =
      canvas.height -
      padding -
      (canvas.height - 2 * padding) * (yValue / maxPrice);

    // Y-axis price label.
    ctx.fillStyle = "#333";
    ctx.textAlign = "right";
    ctx.font = "12px Roboto, sans-serif";
    ctx.fillText(yValue.toFixed(0), padding - 10, y + 3);

    // Light horizontal grid line.
    ctx.beginPath();
    ctx.moveTo(padding, y);
    ctx.lineTo(canvas.width - padding, y);
    ctx.strokeStyle = "#eee";
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // Draw the bars and their labels.
  data.forEach((item, index) => {
    const x = padding + gap + index * (barWidth + gap);
    const barHeight = (item.price / maxPrice) * (canvas.height - 2 * padding);
    const y = canvas.height - padding - barHeight;

    // Create a vertical gradient for each bar.
    const gradient = ctx.createLinearGradient(x, y, x, canvas.height - padding);
    gradient.addColorStop(0, "#6DD5FA"); // light blue
    gradient.addColorStop(1, "#2980B9"); // dark blue
    ctx.fillStyle = gradient;
    ctx.fillRect(x, y, barWidth, barHeight);

    // Year label below each bar.
    ctx.fillStyle = "#333";
    ctx.textAlign = "center";
    ctx.font = "12px Roboto, sans-serif";
    ctx.fillText(item.year, x + barWidth / 2, canvas.height - padding + 15);

    // Price label on top of each bar.
    ctx.fillText(item.price, x + barWidth / 2, y - 5);
  });
});
